import { NgModule } from '@angular/core';
import { MultiSelectModule, ButtonModule, AccordionModule, EditorModule, DropdownModule, ConfirmDialogModule, ConfirmationService, FileUploadModule, DataTableModule, SharedModule, CheckboxModule, TooltipModule, DialogModule, ScheduleModule, CalendarModule, RadioButtonModule,TabViewModule } from 'primeng/primeng';
import { MenuItem } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
@NgModule({
    imports: [
        MultiSelectModule,
        ButtonModule,
        EditorModule,
        FileUploadModule,
        ScheduleModule,
        CalendarModule,
        RadioButtonModule,
        TooltipModule,
        DataTableModule,
        ConfirmDialogModule,
        DropdownModule,      
        SharedModule,
        AccordionModule,
        TabViewModule

    ],
    exports: [MultiSelectModule, ButtonModule,DropdownModule, EditorModule, FileUploadModule, TooltipModule, CheckboxModule, DialogModule, ScheduleModule, CalendarModule, ConfirmDialogModule,
         RadioButtonModule, DataTableModule,
        SharedModule, AccordionModule,TabViewModule],
    providers: [  ConfirmationService,]
})

export class PrimeNgModule { }


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/shared/primeng/primengmodule.ts